import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
import history from '../../history'
import ReactTable from 'react-table'
import { actions } from '../../redux/modules/leadsActions'
import { actions as companiesActions } from '../../redux/modules/companiesActions'
import { actions as organizationsActions } from '../../redux/modules/organizationsActions'
import { actions as leadContactActions } from '../../redux/modules/leadFunctions/leadContactActions'
import moment from 'moment'
import {
  Form,
  Modal,
  Input,
  Select,
  AutoComplete,
  Icon,
  DatePicker,
  message,
  Tooltip,
  Tabs
} from 'antd'
import { convertToOption, filterCaseInsensitive, convertNamesToOption } from '../../util'
import PaginationComponent from '../../components/PaginationComponent'
import _ from 'lodash'
import OrganizationQuickAdd from '../../components/organization//OrganizationQuickAdd'
import InputMask from 'react-input-mask'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'

const TabPane = Tabs.TabPane
const FormItem = Form.Item
const { TextArea } = Input
const Option = Select.Option

const propTypes = {}

class Leads extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      content: null,
      tabKey: '1',
      isLoading: false,
      options: convertToOption(_.get(this.props, 'companiesActions.payload.data'))
    }

    this.props.getAllLeadContacts()
  }

  componentDidUpdate(prevProps) {
    const organizations = _.get(this.props, 'companiesActions.payload.data')
    const prevOrganizations = _.get(prevProps, 'companiesActions.payload.data')

    if (organizations !== prevOrganizations) {
      this.setState({
        organizationOptions: convertToOption(organizations)
      })
    }
  }

  componentWillMount() {
    this.props.leadsRefresh({
      status: this.state.currentLeadFilter ? this.state.currentLeadFilter : 0
    })
    this.props.getAllCompanies()
  }

  handleAddButton = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleCancel = () => {
    this.resetForm({})
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  getSelectedCompany = value => {
    const companies =
      this.props.companiesActions &&
      this.props.companiesActions.payload &&
      this.props.companiesActions.payload.data
    const selectedCompany = companies.find(job => job.name === value)
    return selectedCompany ? +selectedCompany.id : +value
  }

  handleCreate = values => {
    values.organization_id = this.getSelectedCompany(values.organization_id)
    values.bid_due_date = moment(values.bid_due_date).format('YYYY-MM-DD hh:mm:ss')
    values.contactTab = parseInt(this.state.tabKey, 10)
    this.props.createLead({
      content: values,
      userId: this.props.authentication.user.userId
    })

    message.success('Lead created.original.')
    this.setState({ contentData: null, currentId: 0, modalVisible: false })
  }

  /* Organization Quick Add */
  handleQuickAddOrganization = organization => {
    this.props.createNewOrganization({
      organization: organization,
      userId: this.props.authentication.user.userId,
      next: (err, payload) => {
        this.props.getAllCompanies((err, payload) => {
          this._handleSearch(organization.name)
        })
      }
    })
  }

  handleBlurOrganization = organization => {
    if (organization !== '')
      this.setState({
        quickAddModalVisibility:
          _.findIndex(this.props.companiesActions.payload.data, { id: +organization }) < 0 &&
          _.findIndex(this.props.companiesActions.payload.data, { name: organization }) < 0
            ? true
            : false
      })
  }

  handleCancelQuickAdd = () => {
    this.setState({
      quickAddModalVisibility: !this.state.quickAddModalVisibility
    })
  }
  /* End Organization Quick Add */

  handleChangeTab = key => {
    this.setState({
      tabKey: key
    })
  }

  get validationSchema() {
    const { tabKey } = this.state

    const schema = {
      type: Yup.string('Lead type cannot be blank.').required('Lead type cannot be blank.'),
      bid_due_date: Yup.string().required('Bid due date cannot be blank.'),
      organization_id: Yup.string().required('Must choose an organization.'),
      zip:
        Yup.string().required('Zip cannot be blank.') &&
        Yup.string().test('len', 'Zip must be valid.', val => val && val.toString().length === 5),
      address1: Yup.string().required('Street address cannot be blank.'),
      city: Yup.string().required('City cannot be blank.'),
      state: Yup.string().required('State cannot be blank.'),
      name: Yup.string().required('Project Name cannot be blank.'),
      description: Yup.string().required('Description cannot be blank.')
    }

    if (parseInt(tabKey, 10) === 1) {
      schema.contact = Yup.string().required('Contact cannot be blank.')
    } else {
      schema.first_name = Yup.string().required('First Name cannot be blank.')
      schema.last_name = Yup.string().required('Last Name cannot be blank.')
      schema.phone_number = Yup.string().test('len', 'Phone number must be valid.', val => {
        var processedValue = val.replace(/[^0-9]+/g, '')
        return processedValue && processedValue.toString().length >= 10
      })
      schema.organization_contact_id = Yup.string().required('Organization cannot be blank.')
    }

    return Yup.object().shape(schema)
  }

  handleSelectedItem = itemId => {
    const { organizationOptions } = this.state
    const selectedItem = itemId ? organizationOptions.find(option => option.value === itemId) : null
    return selectedItem
  }

  _handleSearch = query => {
    this.setState({ isLoading: true })
    const searchOnItems = async query => {
      const organizations = _.get(this.props, 'companiesActions.payload.data')
      const foundItems = organizations.filter(
        organization => organization.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
      )
      return convertToOption(foundItems)
    }

    searchOnItems(query).then(options => {
      this.setState({
        isLoading: false,
        options: options
      })
    })
  }

  render() {
    const { payload } = this.props.leadsActions
    const allContacts = _.get(this.props, 'leadContactActions.allContacts.data')
    const organizations = _.get(this.props, 'companiesActions.payload.data')
    const { isLoading, options } = this.state

    if (!payload) {
      return (
        <div>
          <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      )
    } else {
      return (
        <div>
          <OrganizationQuickAdd
            modalVisible={this.state.quickAddModalVisibility}
            handleCancel={this.handleCancelQuickAdd}
            handleQuickAddOrganization={this.handleQuickAddOrganization}
          />
          <Formik
            onSubmit={(values, { resetForm }) => {
              this.handleCreate(values)
              resetForm({})
            }}
            validationSchema={this.validationSchema}
            render={props => {
              const { tabKey } = this.state
              this.resetForm = props.resetForm
              this.validateForm = props.validateForm

              return (
                <Modal
                  visible={this.state.modalVisible}
                  title="Create a new lead"
                  okText={'Create'}
                  onCancel={this.handleCancel}
                  onOk={props.handleSubmit}
                  width={'90%'}
                  maskClosable={false}
                >
                  <Form layout="vertical" onSubmit={props.handleSubmit} context={{ tabKey }}>
                    <div className="row">
                      <div className="col-md-6">
                        <fieldset>
                          <legend>LEAD DETAILS</legend>
                          <div className="row">
                            <div className="col-md-6">
                              <FormItem
                                label="Lead Type"
                                validateStatus={props.errors.type ? 'error' : ''}
                                help={props.errors.type}
                                required
                              >
                                <Select
                                  onChange={value => props.setFieldValue('type', value)}
                                  style={{ width: '100%' }}
                                  name="type"
                                  value={props.values.type && props.values.type.toString()}
                                >
                                  <Option value="MRL">MRL</Option>
                                  <Option value="HC">HC</Option>
                                  <Option value="TC">TC</Option>
                                  <Option value="M">M</Option>
                                  <Option value="MOD">MOD</Option>
                                  <Option value="R">R</Option>
                                  <Option value="S">S</Option>
                                  <Option value="HMS">HMS</Option>
                                </Select>
                              </FormItem>
                            </div>
                            <div className="col-md-6">
                              <FormItem
                                label="Bid Due Date"
                                validateStatus={props.errors.bid_due_date ? 'error' : ''}
                                help={props.errors.bid_due_date}
                                required
                              >
                                <DatePicker
                                  onChange={(m, value) => {
                                    return props.setFieldValue('bid_due_date', value)
                                  }}
                                  name="bid_due_date"
                                  value={
                                    (props.values.bid_due_date &&
                                      moment(props.values.bid_due_date, 'YYYY-MM-DD hh:mm:ss')) ||
                                    undefined
                                  }
                                />
                              </FormItem>
                            </div>
                          </div>

                          <FormItem
                            label="Organization"
                            validateStatus={props.errors.organization_id ? 'error' : ''}
                            help={props.errors.organization_id}
                            required
                          >
                            <AsyncTypeahead
                              id="organization_id"
                              key="organization_id"
                              delay={200}
                              useCache={false}
                              isLoading={isLoading}
                              labelKey="text"
                              options={options}
                              minLength={1}
                              onSearch={this._handleSearch}
                              placeholder="Search for some Organization..."
                              onBlur={() => {
                                if (this.state.options.length === 0) {
                                  if (
                                    window.confirm(
                                      'You have entered a company name that does not exist. Or you did not selected from the list. Would you like to create it?'
                                    )
                                  ) {
                                    this.setState({
                                      quickAddModalVisibility: true
                                    })
                                  }
                                }
                              }}
                              onChange={selected => {
                                props.setFieldValue('organization_id', selected[0].value)
                              }}
                            />
                          </FormItem>
                          <FormItem
                            name="zip"
                            label="ZIP Code"
                            validateStatus={props.errors.zip ? 'error' : ''}
                            help={props.errors.zip}
                            required
                          >
                            <Input
                              onChange={props.handleChange}
                              name="zip"
                              placeholder="type the ZIP Code"
                              value={props.values.zip}
                            />
                          </FormItem>
                          <div className="row">
                            <div className="col-md-6">
                              <FormItem
                                label="Street Address"
                                validateStatus={props.errors.address1 ? 'error' : ''}
                                help={props.errors.address1}
                                required
                              >
                                <Input
                                  onChange={props.handleChange}
                                  name="address1"
                                  placeholder="Street and number, P.O. box, C/o."
                                  value={props.values.address1}
                                />
                              </FormItem>
                            </div>
                            <div className="col-md-6">
                              <FormItem
                                label="City"
                                validateStatus={props.errors.city ? 'error' : ''}
                                help={props.errors.city}
                                required
                              >
                                <Input
                                  onChange={props.handleChange}
                                  name="city"
                                  placeholder="City"
                                  value={props.values.city}
                                />
                              </FormItem>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <FormItem label="Street Address (cont.)">
                                <Input
                                  name="address2"
                                  placeholder="Apartment, suite, unit, building, floor, etc."
                                  values={props.values.address2}
                                />
                              </FormItem>
                            </div>
                            <div className="col-md-6">
                              <FormItem
                                label="State"
                                validateStatus={props.errors.state ? 'error' : ''}
                                help={props.errors.state}
                                required
                              >
                                <Input
                                  onChange={props.handleChange}
                                  name="state"
                                  placeholder="State"
                                  value={props.values.state}
                                />
                              </FormItem>
                            </div>
                          </div>

                          <FormItem
                            label="Project Name"
                            validateStatus={props.errors.name ? 'error' : ''}
                            help={props.errors.name}
                            required
                          >
                            <Input
                              onChange={props.handleChange}
                              name="name"
                              placeholder="Your project name..."
                              value={props.values.name}
                            />
                          </FormItem>
                          <FormItem
                            label="Description"
                            validateStatus={props.errors.description ? 'error' : ''}
                            help={props.errors.description}
                            required
                          >
                            <TextArea
                              name="description"
                              placeholder="Describe your project..."
                              rows={4}
                              onChange={props.handleChange}
                              value={props.values.description}
                            />
                          </FormItem>
                        </fieldset>
                      </div>
                      <div className="col-md-6">
                        <fieldset>
                          <legend>CONTACT INFORMATION</legend>
                          <Tabs
                            defaultActiveKey="1"
                            activeKey={tabKey}
                            onChange={this.handleChangeTab}
                          >
                            <TabPane tab="Select" key="1">
                              <div className="row">
                                <div className="col-md-12">
                                  <FormItem
                                    label="Contact"
                                    validateStatus={props.errors.contact ? 'error' : ''}
                                    help={props.errors.contact}
                                    required
                                  >
                                    <AutoComplete
                                      dataSource={convertNamesToOption(allContacts)}
                                      style={{ width: 320 }}
                                      filterOption={(inputValue, option) =>
                                        option.props.children
                                          .toUpperCase()
                                          .indexOf(inputValue.toUpperCase()) !== -1
                                      }
                                      placeholder="Search for a contact"
                                      name="contact"
                                      onChange={value => props.setFieldValue('contact', value)}
                                      value={props.values.contact}
                                    >
                                      <Input
                                        suffix={
                                          <Icon type="search" className="certain-category-icon" />
                                        }
                                      />
                                    </AutoComplete>
                                  </FormItem>
                                </div>
                              </div>
                            </TabPane>
                            <TabPane tab="Create" key="2">
                              <div className="row">
                                <div className="col-md-12">
                                  <FormItem
                                    label="Company"
                                    validateStatus={
                                      props.errors.organization_contact_id ? 'error' : ''
                                    }
                                    help={props.errors.organization_contact_id}
                                    required
                                  >
                                    <AutoComplete
                                      dataSource={organizations && convertToOption(organizations)}
                                      filterOption={(inputValue, option) =>
                                        option.props.children
                                          .toUpperCase()
                                          .indexOf(inputValue.toUpperCase()) !== -1
                                      }
                                      style={{ width: 320 }}
                                      placeholder="Search for a Company"
                                      onBlur={this.props.handleBlurOrganization}
                                      name="organization_contact_id"
                                      onChange={value =>
                                        props.setFieldValue('organization_contact_id', value)
                                      }
                                      value={props.values.organization_contact_id}
                                    >
                                      <Input
                                        suffix={
                                          <Icon type="search" className="certain-category-icon" />
                                        }
                                      />
                                    </AutoComplete>
                                  </FormItem>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6">
                                  <FormItem
                                    label="First Name"
                                    validateStatus={props.errors.first_name ? 'error' : ''}
                                    help={props.errors.first_name}
                                    required
                                  >
                                    <Input
                                      name="first_name"
                                      placeholder="Type in a first name..."
                                      onChange={props.handleChange}
                                      value={props.values.first_name}
                                    />
                                  </FormItem>
                                </div>
                                <div className="col-md-6">
                                  <FormItem
                                    label="Last Name"
                                    validateStatus={props.errors.last_name ? 'error' : ''}
                                    help={props.errors.last_name}
                                    required
                                  >
                                    <Input
                                      onChange={props.handleChange}
                                      name="last_name"
                                      placeholder="Type in a last name..."
                                      value={props.values.last_name}
                                    />
                                  </FormItem>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6">
                                  <FormItem label="Title">
                                    <Input
                                      onChange={props.handleChange}
                                      name="title"
                                      placeholder="Type in the title..."
                                      value={props.values.title}
                                    />
                                  </FormItem>
                                </div>
                                <div className="col-md-6">
                                  <FormItem label="Email">
                                    <Input
                                      onChange={props.handleChange}
                                      name="email"
                                      placeholder="Type in email address..."
                                      value={props.values.email}
                                    />
                                  </FormItem>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6">
                                  <FormItem
                                    label="Phone Number"
                                    validateStatus={props.errors.phone_number ? 'error' : ''}
                                    help={props.errors.phone_number}
                                    required
                                  >
                                    <InputMask
                                      className="ant-input"
                                      mask="(999) 999-9999 ext:9999"
                                      maskChar="_"
                                      name="phone_number"
                                      onChange={props.handleChange}
                                      value={props.values.phone_number}
                                    />
                                  </FormItem>
                                </div>
                                <div className="col-md-6">
                                  <FormItem label="Mobile Number">
                                    <InputMask
                                      className="ant-input"
                                      mask="(999) 999-9999 ext:9999"
                                      maskChar="_"
                                      name="mobile_number"
                                      onChange={props.handleChange}
                                      value={props.values.mobile_number}
                                    />
                                  </FormItem>
                                </div>
                              </div>
                            </TabPane>
                          </Tabs>
                        </fieldset>
                      </div>
                    </div>
                  </Form>
                </Modal>
              )
            }}
          />
          <div className="dataHeader">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/leads">Leads</Link>
                </li>
              </ol>
            </nav>
            <h2>Leads</h2>
          </div>
          <div className="dataPanel">
            <div className="wrapPanel">
              <div className="jobsBar">
                Leads
                <div className="jobsBarAdd">
                  <i className="fa fa-plus-square" aria-hidden="true" />
                  &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
                    NEW LEAD
                  </div>
                </div>
              </div>
              <ReactTable
                data={payload.data}
                getTdProps={(state, rowInfo, column, instance) => ({
                  onClick: e => history.push(`/lead/${rowInfo.original.id}`)
                })}
                filterable
                defaultFilterMethod={filterCaseInsensitive}
                PaginationComponent={PaginationComponent}
                columns={[
                  {
                    columns: [
                      {
                        Header: 'Project name',
                        id: 'name',
                        accessor: 'name',
                        Cell: d => <Tooltip title={d.original.name}>{d.original.name}</Tooltip>
                      },
                      {
                        Header: 'Type',
                        accessor: 'type',
                        id: 'type',
                        minWidth: 30,
                        Cell: d => {
                          const r = `${d.original.type ? d.original.type : 'N/A'}`
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      },
                      {
                        Header: 'Address',
                        id: 'address',
                        accessor: 'address',
                        minWidth: 100,
                        Cell: d => {
                          const r = `${d.original.address1 !== null && d.original.address1}${
                            d.original.address2 !== null ? ' ' + d.original.address2 : ''
                          }${d.original.city !== null ? ', ' + d.original.city : ''}${
                            d.original.state !== null ? ' - ' + d.original.state : ''
                          }${d.original.zip !== null ? ' - ' + d.original.zip : ''}`
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      },
                      {
                        Header: 'Company',
                        id: 'organization_name',
                        accessor: 'organization_name',
                        minWidth: 70,
                        Cell: d => (
                          <Tooltip title={d.original.organization_name}>
                            {d.original.organization_name}
                          </Tooltip>
                        )
                      },
                      {
                        Header: 'Primary Contact',
                        id: 'primary_contact',
                        accessor: d => {
                          const r = d.contact_first_name
                            ? `${d.contact_first_name} ${d.contact_last_name}`
                            : 'Contact Not Assigned'
                          return r
                        },
                        minWidth: 70,
                        Cell: d => {
                          const r = d.original.contact_first_name
                            ? `${d.original.contact_first_name} ${d.original.contact_last_name}`
                            : 'Contact Not Assigned'
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      },
                      {
                        Header: 'Stage',
                        accessor: 'status',
                        minWidth: 50
                      },
                      {
                        Header: 'Dead',
                        accessor: 'dead',
                        minWidth: 50,
                        Cell: row => {
                          return (
                            <span>
                              <span
                                style={{
                                  color: row.value === 1 ? 'red' : 'green',
                                  transition: 'all .3s ease'
                                }}
                              >
                                &#x25cf;
                              </span>
                              {row.value === 1 ? ' Yes' : ' No'}
                            </span>
                          )
                        },
                        filterMethod: (filter, row) => {
                          if (filter.value === 'all') return true
                          if (parseInt(filter.value, 10) === 0 && !row.dead) return true
                          return parseInt(filter.value, 10) === row.dead
                        },
                        Filter: ({ filter, onChange }) => (
                          <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: '100%' }}
                            value={filter ? filter.value : 'all'}
                          >
                            <option value="all">All</option>
                            <option value="0">Alive</option>
                            <option value="1">Dead</option>
                          </select>
                        )
                      },
                      {
                        Header: 'Completed',
                        accessor: 'completed',
                        minWidth: 50,
                        Cell: row => {
                          return (
                            <span>
                              <span
                                style={{
                                  color: row.value === 1 ? 'green' : 'grey',
                                  transition: 'all .3s ease'
                                }}
                              >
                                &#x25cf;
                              </span>
                              {row.value === 1 ? ' Yes' : ' No'}
                            </span>
                          )
                        },
                        filterMethod: (filter, row) => {
                          if (filter.value === 'all') return true
                          if (parseInt(filter.value, 10) === 0 && _.isNull(row.completed))
                            return true
                          return parseInt(filter.value, 10) === row.completed
                        },
                        Filter: ({ filter, onChange }) => (
                          <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: '100%' }}
                            value={filter ? filter.value : 'all'}
                          >
                            <option value="all">All</option>
                            <option value="0">Not Completed</option>
                            <option value="1">Completed</option>
                          </select>
                        )
                      },
                      {
                        Header: 'Created Date',
                        id: 'created_date',
                        accessor: d => moment.utc(d.created_date).format('M/D/YYYY'),
                        minWidth: 50,
                        sortMethod: (a, b) => {
                          const mA = moment.utc(a)
                          const mB = moment.utc(b)
                          if (mA.isAfter(mB)) {
                            return 1
                          } else if (mA.isSame(mB)) {
                            return 0
                          } else {
                            return -1
                          }
                        }
                      }
                    ]
                  }
                ]}
                defaultSorted={[
                  {
                    id: 'id',
                    desc: true
                  }
                ]}
                defaultPageSize={10}
                className="-striped -highlight"
              />
              <br />
              &copy; 2018 G-Tech Elevator Associates LLC
            </div>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = (
  { leadsActions, authentication, companiesActions, organizationsActions, leadContactActions },
  ownProps
) => ({
  leadsActions,
  authentication,
  companiesActions,
  organizationsActions,
  leadContactActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign(
      {},
      actions,
      companiesActions,
      companiesActions,
      organizationsActions,
      leadContactActions
    ),
    dispatch
  )
})

Leads.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(Leads)))



// WEBPACK FOOTER //
// ./src/pages/leads/Leads.container.js